export default __webpack_public_path__ + "057b9b40c83ab9425d0a4448d60d2287.png";